import appApi from '../../../../../../api/app-api';
import globalUserPage from '../../../../../../stores/global-user-page';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';
import { UserSummaryType } from '../../../../../../api/types/user/user-summary.type';

export const cancelInstallmentItemBankTransferOperation = async (
  user: UserSummaryType,
  installmentPlanId: number,
  installmentId: number,
  shouldSplitRemainder: boolean,
  setLoading: (loading: boolean) => void,
  onSuccess?: () => void,
): Promise<boolean> => {
  try {
    setLoading(true);

    const res = await appApi.cancelInstallmentBankTransfer(
      installmentPlanId,
      installmentId,
      shouldSplitRemainder,
    );

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return false;
    }

    // Refresh user details to get updated installments
    const updatedUserDetails = await appApi.getUserStudentDetails(user.id);
    globalUserPage.studentDetails = updatedUserDetails.data.body;

    toast.success('התשלום בוטל בהצלחה');
    setLoading(false);
    onSuccess?.();
    return true;
  } catch (e) {
    console.error('Error canceling bank transfer installment:', e);
    toast.error('שגיאה בביטול התשלום');
    setLoading(false);
    return false;
  }
};
